import React from 'react';
import { PageHeader, Image, Typography, Row, Col } from 'antd';
import { css } from '@emotion/react';
import { ButtonActionPage } from '../../atoms';
import { IconSorting } from '../../../assets';

interface ContentPageHeaderProps {
  title: string;
  footer?: string;
  extra?: ExtraHeaderPage[];
  extraDropdown?: any;
  sortingEnabled?: Boolean;
}

export interface ExtraHeaderPage {
  key: string | number;
  text: string;
  bgWhite?: string;
  onClick?: () => void;
  icon?: React.ReactElement;
  className?: string;
}

const SortingEnabledTitle = () => {
  return (
    <Row gutter={12} style={{ display: 'flex' }}>
      <Col style={{ alignItems: 'center', display: 'flex' }}>
        <Image wrapperStyle={{ width: 24, height: 24 }} src={IconSorting} preview={false} />
        <Typography.Text style={{ color: 'rgba(0, 190, 75, 1)', fontWeight: 600, fontSize: 14, marginLeft: 5 }}>
          Sorting Enabled
        </Typography.Text>
      </Col>
    </Row>
  );
};

export const ContentPageHeader = (props: ContentPageHeaderProps) => {
  const { title, footer, extra, extraDropdown, sortingEnabled } = props;
  const ext =
    extra &&
    extra.map((item, index) => {
      const propExtra = {
        id: item.key,
        ...item,
      };

      return <ButtonActionPage {...propExtra} />;
    });
  if (extraDropdown) {
    ext?.unshift(extraDropdown);
  }
  if (sortingEnabled) {
    ext?.unshift(<SortingEnabledTitle />);
  }
  return <PageHeader style={{ alignItems: 'center' }} title={title} footer={footer} extra={ext} css={style} />;
};

const style = css`
  .ant-page-header-heading-extra {
    flex-direction: row;
    justify-content: center;
    display: flex;
    align-items: center;
  }
`;
